"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MozartCoreStorageV1Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MozartCoreStorageV1Factory = /** @class */ (function (_super) {
    __extends(MozartCoreStorageV1Factory, _super);
    function MozartCoreStorageV1Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MozartCoreStorageV1Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MozartCoreStorageV1Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MozartCoreStorageV1Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MozartCoreStorageV1Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MozartCoreStorageV1Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MozartCoreStorageV1Factory;
}(contracts_1.ContractFactory));
exports.MozartCoreStorageV1Factory = MozartCoreStorageV1Factory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "positionCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5060ad8061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80635c975abb146037578063e7702d05146051575b600080fd5b603d6069565b604080519115158252519081900360200190f35b60576072565b60408051918252519081900360200190f35b60005460ff1681565b6001548156fea265627a7a723158208b47a5d2a31510d79a9ac6417cc7a9179ef17dcbd67675a2c45d43e6bf2632e964736f6c63430005100032";
//# sourceMappingURL=MozartCoreStorageV1Factory.js.map